// extracted by mini-css-extract-plugin
export var background = "slide-module--background--LIQzc";
export var grid = "slide-module--grid--M4myZ";
export var textarea = "slide-module--textarea--z196U";